import styled from 'styled-components';
import plusRound from '~/assets/icons/plus_round.svg';

const StyledContainer = styled.div`
	position: relative;
	padding: 64px 20px 0;
`;

const StyledHead = styled.div`
	display: grid;
	grid-template-columns: 60px 1fr 60px;
	gap: 10px;
	align-items: center;

	& > img {
		user-select: none;
	}
`;

const StyledCreateButton = styled.div`
	justify-self: end;
	width: 20px;
	height: 20px;
	background-image: url(${plusRound});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	cursor: pointer;
	transition: opacity 0.3s ease;
	opacity: 0.5;

	&:hover {
		opacity: 1;
	}
`;

const StyledScrollContainerWrapper = styled.div`
	margin-top: 20px;
`;

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-bottom: 80px;
`;

const StyledEmptyList = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 375px;
`;

export {
	StyledContainer,
	StyledCreateButton,
	StyledEmptyList,
	StyledHead,
	StyledList,
	StyledScrollContainerWrapper,
};
